var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditFormInert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4279 13.4142C24.2089 12.6332 25.4753 12.6332 26.2563 13.4142L26.5858 13.7437C27.3668 14.5247 27.3668 15.7911 26.5858 16.5721L18.9545 24.2034C18.6753 24.4826 18.3197 24.6729 17.9325 24.7503L14.8731 25.3622C14.7332 25.3902 14.6098 25.2668 14.6378 25.1269L15.2497 22.0675C15.3271 21.6803 15.5174 21.3247 15.7966 21.0455L23.4279 13.4142Z",
    stroke: "#888281"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0003 14L26.0003 18",
    stroke: "#888281"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFormInert);
export default __webpack_public_path__ + "static/media/edit-form-inert.410e0bef19e5fa01fefc457c636d3d9c.svg";
export { ForwardRef as ReactComponent };